package com.vizio.redwolf.auth.api

import com.vizio.redwolf.utils.Environment
import com.vizio.redwolf.utils.EnvironmentGroup
import com.vizio.redwolf.utils.PurchasePinEnvironmentConfig
import kotlin.js.JsExport

@JsExport
interface PinEnvironment : Environment {
    val proxyHost: String
    val pinPath: String
}

@JsExport
data class DevPinEnvironment(
    override val proxyHost: String = "dev.redwolf.external.plat.vizio.com",
    override val pinPath: String = "/pin-svc"
) : PinEnvironment

@JsExport
data class StagePinEnvironment(
    override val proxyHost: String = "stage.redwolf.external.plat.vizio.com",
    override val pinPath: String = "/pin-svc"
) : PinEnvironment

@JsExport
data class PreProdPinEnvironment(
    override val proxyHost: String = "preprod.redwolf.external.plat.vizio.com",
    override val pinPath: String = "/pin-svc"
) : PinEnvironment

@JsExport
data class ProdPinEnvironment(
    override val proxyHost: String = "prod.redwolf.external.plat.vizio.com",
    override val pinPath: String = "/pin-svc"
) : PinEnvironment

fun choosePinEnvironment(envConfig: PurchasePinEnvironmentConfig): PinEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdPinEnvironment()
        EnvironmentGroup.PREPROD -> PreProdPinEnvironment()
        EnvironmentGroup.STAGE -> StagePinEnvironment()
        EnvironmentGroup.DEV -> DevPinEnvironment()
        EnvironmentGroup.TEST -> TODO("TEST env not defined for PinEnvironment!")
    }
}
